import { ProcessorType } from '../@types';

import { provider as StripeProvider } from './providers/StripeProvider';
import { provider as AdyenProvider } from './providers/AdyenProvider';

export { PaymentEvents, emitter } from '../utils/emitter';

const Providers: Record<ProcessorType, any> = {
  stripe: StripeProvider,
  adyen: AdyenProvider,
  paypal: null,
  dlocal: null,
};

const createProviderFactory = (gateway: ProcessorType) => Providers[gateway];

export { createProviderFactory };
